export default "__VITE_ASSET__5p10v90h__"